import { CircleAlert } from "lucide-react";
import { Link } from "react-router";

import { Button } from "@/components/ui/button";

/** Keep navigation available when a page or a lazy chunk fails. */
export function RouteError() {
  return (
    <div
      role="alert"
      className="mx-auto flex max-w-md flex-col items-center gap-3 py-20 text-center"
    >
      <CircleAlert className="text-destructive size-8" />
      <h1 className="text-xl font-semibold">This page couldn’t load</h1>
      <p className="text-muted-foreground text-sm">
        Check your connection and reload to get the latest dashboard version.
        You can also open another page from the navigation.
      </p>
      <div className="mt-2 flex gap-2">
        <Button onClick={() => window.location.reload()}>Reload page</Button>
        <Button variant="outline" asChild>
          <Link to="/">Go home</Link>
        </Button>
      </div>
    </div>
  );
}
